/**
 * This is modal contaioner
 * Used to export const modal that has function: confirm,alert etc.
 */
import React, { useState } from 'react';
import ModalSimple from './ModalSimple';
import ModalInput from './ModalInput';

var _modal = {};

const ModalContainer = () => {
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState(false);

  //data = { title, caption, message, buttons }
  _modal.showModal = data => {
    setModalShow(true);
    setData(data);
  };

  return data.input ? (
    <ModalInput
      title={data.title}
      caption={data.caption}
      lines={data.lines}
      buttons={data.buttons}
      show={modalShow}
      setShow={setModalShow}
    />
  ) : (
    <ModalSimple
      title={data.title}
      caption={data.caption}
      message={data.message}
      buttons={data.buttons}
      show={modalShow}
      setShow={setModalShow}
    />
  );
};

const modal = {
  /**
   *
   * @param {*} title
   * @param {*} caption
   * @param {*} message
   * @param {*} buttons Array of button. botton.variant is one of [outline-]primary,secondary,success,warning,danger,info,light,dark,link
   */
  dialog: function (title, caption, message, buttons) {
    _modal.showModal({
      title,
      caption,
      message,
      buttons
    });
  },

  /**
   *
   * @param {*} title
   * @param {*} caption
   * @param {*} message
   * @param {*} buttons
   */
  confirm: function (title, caption, message, buttonText, buttonClick) {
    if (!title && !caption && !message) {
      buttonClick();
    } else {
      _modal.showModal({
        title,
        caption,
        message,
        buttons: [
          {
            text: buttonText,
            click: buttonClick
          },
          {
            variant: 'secondary',
            text: '__Close'
          }
        ]
      });
    }
  },

  /**
   *
   * @param {*} title
   * @param {*} caption
   * @param {*} message
   */
  alter: function (title, caption, message) {
    _modal.showModal({
      title,
      caption,
      message
    });
  },

  /**
   *
   * @param {*} title
   * @param {*} caption
   * @param {*} message
   */
  input: function (title, caption, lines, buttons) {
    _modal.showModal({
      input: true,
      title,
      caption,
      lines,
      buttons
    });
  }
};

export { modal, ModalContainer };
